import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 41862 41862"
    {...props}
  >
    <path
      d="M1434 1434h27526c6307 0 11468 5161 11468 11469v16057c0 6307-5161 11468-11468 11468H12903c-6308 0-11469-5161-11469-11468V1434z"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 2867.25,
      }}
      className="stroke1"
    />
  </svg>
)
export default SvgComponent
